import {useSuggestiveSellingContext} from '../context/suggestive-selling-context';

export function useSuggestiveSellingPending(pendingKey?: string | null): boolean {
    const {isPending} = useSuggestiveSellingContext();
    if (!pendingKey) {
        return false;
    }
    return isPending(pendingKey);
}
